import { useEffect, useMemo } from "react";

import { UIView } from "@uirouter/react";

import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";
import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_SIGNALS } from "app/pages/sales-intelligence/constants/routes";
import useSignalsEventsQuery from "app/pages/sales-intelligence/modules/company-analysis/queries/useSignalsEventsQuery";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import PageTitle from "app/pages/sales-intelligence/pages/company-analysis/components/shared/PageTitle/PageTitle";
import { Tabs } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Tabs/Tabs";
import CompanyPageHeader from "app/pages/sales-intelligence/pages/company-analysis/containers/header/PageHeader/CompanyPageHeader";
import { COMPANY_ANALYSIS_TABS } from "app/pages/sales-intelligence/pages/company-analysis/routing/company-tabs-config";
import { useCompanyName } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCompanyName";
import type { NavigationTabConfig } from "app/pages/sales-intelligence/modules/company-analysis/types/navigation-tabs";
import updateTrackingQueryParams from "app/pages/sales-intelligence/sub-modules/common/utils/updateTrackingQueryParams";

const CompanyRootPage = () => {
    useEffect(() => {
        updateTrackingQueryParams();
    }, []);

    const ref = useAutoScrollTop();

    const { data, isLoading } = useSignalsEventsQuery();
    const companyName = useCompanyName();

    const tabsConfig = useMemo((): readonly NavigationTabConfig[] => {
        return COMPANY_ANALYSIS_TABS.map((tab) => {
            if (tab.stateId === COMPANY_ANALYSIS_SIGNALS) {
                return {
                    ...tab,
                    count: data?.length ?? 0,
                    isLoading: isLoading,
                };
            }
            return tab;
        });
    }, [data, isLoading]);

    const handleTabClick = (tabName: string) => {
        companyAnalysisTrackingService.trackCompanyTabClick(tabName, companyName);
    };

    return (
        <>
            <CompanyPageHeader />
            <div
                className="sw-layout-scrollable-element"
                ref={ref}
            >
                <PageTitle text={translate("si.company-analysis.company.title")} />
                <Tabs
                    config={tabsConfig}
                    onTabClick={handleTabClick}
                />
                <div className="sw-layout-page">
                    <UIView />
                </div>
            </div>
        </>
    );
};

export default CompanyRootPage;
